module.exports = __webpack_public_path__ + "img/Middle-Bevel-Attachment-48.f5061dc5.png";